import { all, takeLatest, put, select } from 'redux-saga/effects';
import { matchesType } from '../../sagas';
import { pastOrders as actions } from '../../../Actions';
import { startSyncCounters, getStatus, postReason } from '../../../Api/pastOrdersApiClient';
import { NotificationAlert, NotificationType } from '../../../CommonUI';
import { getBusinessUnitTierFeatures } from '../../../Api/tiersClient';
import { getIntegrationConfig, integrationConfig } from '../../../Api/configapiClient';
import { consentIsAccepted } from '../../../Api/businessConsentsClient';
import { getInvitationSettings } from '../../../Api/invitationSettingsClient';

function getPastOrdersTabSettings(businessUnitId: string) {
  return Promise.all([
    getBusinessUnitTierFeatures(businessUnitId),
    getIntegrationConfig(businessUnitId),
    getInvitationSettings(businessUnitId),
  ]);
}

function* startSync() {
  try {
    const { period, selectedShops } = yield select((state) => state.PastOrders);
    const { account } = yield select((state) => state.App);
    const pastOrderValue = {
      pastOrders: {
        shops: selectedShops,
        period,
        showInitial: false,
      }
    };
    yield integrationConfig(account.businessUnitId, pastOrderValue);
    yield startSyncCounters(account.businessUnitId);
    yield fetchPastOrdersTabSettings();
    yield fetchStatus();
  } catch (err) {
    console.log(err);
  }
}

function* loadIntegrationKey(ms = 400, tryCount = 5) {
  let app = yield select((state) => state.App);
  while (app.isFetching && tryCount > 0) {
    tryCount--;
    yield new Promise((resolve) => setTimeout(resolve, ms));
    app = yield select((state) => state.App);
  }
  return app;
}

// @ts-ignore
function* fetchPastOrdersTabSettings() {
  const { integrationKey } = yield loadIntegrationKey();
  const consentResponse = yield consentIsAccepted(integrationKey);
  if (consentResponse && consentResponse.consentIsAccepted) {
    const [features, config, invitationSettings] = yield getPastOrdersTabSettings(consentResponse.businessUnitId);
    if (features && features.length > 0 && config) {
      yield put(
          actions.receivePastOrdersSettings(config, consentResponse.businessUnitId, invitationSettings, features)
      );
    } else {
      NotificationAlert.alert(NotificationType.Error, 'Notifications.loadDataError');
    }
  }
}

function* fetchStatus() {
  const { account } = yield select((state) => state.App);
  const response = yield getStatus(account.businessUnitId);
  if (response && response.data) {
    yield put(actions.receiveStatus(response.data));
  } else {
    NotificationAlert.alert(NotificationType.Error, 'Notifications.loadDataError');
  }
}

function* updateReason() {
  const { account } = yield select((state) => state.App);
  const { analyze } = yield select((state) => state.PastOrders);
  if (analyze && analyze.code) {
    yield postReason(account.businessUnitId, analyze.code);
  }
}

export function* pastOrders() {
  yield all([takeLatest(matchesType(actions.fetchStatus), fetchStatus)]);
  yield all([takeLatest(matchesType(actions.fetchPastOrdersSettings), fetchPastOrdersTabSettings)]);
  yield all([takeLatest(matchesType(actions.startSync), startSync)]);
  yield all([takeLatest(matchesType(actions.receiveAnalyze), updateReason)]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/PastOrders/index.ts